export default {
    isVisible: false
};
